import { useEffect, useState } from "react";
import { Alert, Button, ListGroup, Modal, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../providers/authprovider";

const DEFAULT_OFFER_TYPES = [
  { id: "offer_aeration", name: "Napowietrzanie" },
  { id: "offer_smoke_removal", name: "Oddymianie" },
  { id: "offer_simple", name: "Prosta" },
];

function getTemplateErrorMessage(error) {
  if (error) return error;

  return "Nie udało się pobrać szablonów ofert.";
}

export default function OfferPriceExportModal({ show, onHide, exportRows }) {
  const navigate = useNavigate();
  const {
    offers: { templates: templatesApi },
  } = useAuth();
  const [templates, setTemplates] = useState([]);
  const [loadingTemplates, setLoadingTemplates] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!show) return;

    setError("");
    setLoadingTemplates(true);

    templatesApi.list(({ success, error, content }) => {
      setLoadingTemplates(false);

      if (!success) {
        setError(getTemplateErrorMessage(error));
        setTemplates([]);
        return;
      }

      setTemplates(content);
    });
  }, [show, templatesApi]);

  const handleCreateDefaultOffer = (offerType) => {
    navigate(`/offers/create/${offerType}`, {
      state: {
        offerPriceRows: exportRows,
        migrateOfferTablesToPriceList: true,
      },
    });
  };

  const handleCreateTemplateOffer = (templateId) => {
    navigate(`/offers/create/template/${templateId}`, {
      state: {
        offerPriceRows: exportRows,
        migrateOfferTablesToPriceList: true,
      },
    });
  };

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Eksportuj do oferty</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <Alert variant="danger">{error}</Alert>}
        <div className="mb-3">Zaznaczone pozycje: {exportRows.length}</div>
        <h6>Nowa oferta</h6>
        <ListGroup className="mb-3">
          {DEFAULT_OFFER_TYPES.map((offerType) => (
            <ListGroup.Item
              action
              key={offerType.id}
              onClick={() => handleCreateDefaultOffer(offerType.id)}
            >
              {offerType.name}
            </ListGroup.Item>
          ))}
        </ListGroup>
        <h6>Nowa oferta z szablonu</h6>
        {loadingTemplates && (
          <div className="d-flex align-items-center gap-2">
            <Spinner animation="border" size="sm" />
            <span>Szablony są pobierane...</span>
          </div>
        )}
        {!loadingTemplates && (
          <ListGroup>
            {templates.length === 0 ? (
              <ListGroup.Item disabled>Brak szablonów</ListGroup.Item>
            ) : (
              templates.map((template) => (
                <ListGroup.Item
                  action
                  key={template.id}
                  onClick={() => handleCreateTemplateOffer(template.id)}
                >
                  {template.name}
                </ListGroup.Item>
              ))
            )}
          </ListGroup>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Zamknij
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
